export default __webpack_public_path__ + "static/media/glitch39.63806c54.png";